import { showToast } from '../../../core/actions/toast/ToastActions';
import { productsApiCall } from '../products/ProductsActions';
import { productSettings } from '../settings/SettingsActions';
import toastMsg from '../../../../data/toast';
import { UNDO_DELETE } from '../../../ActionsConst';
import AnalyticsClient from '../../../../clients/AnalyticsClient';
import toastEvents from '../../../../analytics/events/toasts';

const successToast = (id) =>
  showToast({
    id,
    message: {
      messageDescriptor: toastMsg.productSuccessUndeleteMessage, // Product successfully un-deleted
    },
    action() {},
  });

const errorToast = (id, action) =>
  showToast({
    id,
    action,
    error: true,
    message: {
      messageDescriptor: toastMsg.productErrorUndeleteMessage, // Sorry - we couldn't undo
    },
  });

export const undoDeleteReceive = (ids) => ({
  ids,
  type: UNDO_DELETE,
});

const getProductsApiCall = (ids, requestId, callback) => ({
  callback,
  ids,
  requestId,
  method: 'DELETE',
  url: 'print-products/archive',
  urlConfig: {
    sendIds: ids.length > 0,
    sendPaging: false,
    sendFilters: ids.length === 0,
  },
});

const undoDelete = ({ jsonResponse, error, ids, store, requestId }) => {
  const { dispatch } = store;

  if (error) {
    const retryUndelete = () => {
      dispatch(productsApiCall(getProductsApiCall(ids, requestId, undoDelete)));
      AnalyticsClient.trackEvent(toastEvents.retryAction());
    };

    dispatch(errorToast(requestId, retryUndelete));

    return;
  }

  const currentItems = store.getState().productSettings.total;
  const deletedItems = jsonResponse.succeeded;

  dispatch(undoDeleteReceive(jsonResponse.undeleted));
  dispatch(productSettings({ total: currentItems + Math.max(deletedItems, 0) }));
  dispatch(successToast(requestId));

  AnalyticsClient.trackEvent(toastEvents.undoDelete());
};

export const undoDeleteRequestAction = (ids, requestId) => {
  return productsApiCall(getProductsApiCall(ids, requestId, undoDelete));
};
